import { buildFormData } from "./payload.helper";

const ALLOWED_FIELDS = [
  "patient_type",
  "unit_id",
  "physician_id",
  "patient_name",
  "reg_date",
  "father_husband_name",
  "taluka_id",
  "location",
  "distance",
  "age",
  "dob",
  "gender",
  "patient_cnic",
  "address",
  "mobile",
  "any_govt_id",
  "prescription_pad_no",
  "system_number",
  "diagnosis",
  "other_identifiers",
  "temperature",
  "height",
  "weight",
  "pulse",
  "bp",
  "blood_group",
  "rr",
  "active_medications",
  "inactive_medications",
  "significant_medications",
  "alert_intolerance",
  "visit_history",
  "chief_complaints",
  "care_plan_notes",
  "medical_history",
  "referral_to_specialist",
  "is_referral",
  "ot_date",
  "referred_by",
  "admission_date_time",
  "ward_type",
  "bed",
  "previous_admission_date",
  "previous_discharge_date",
  "note_special_circumstances",
  "status",
  "attachments",
  "existing_attachments",
];

const pickFields = (data) =>
  ALLOWED_FIELDS.reduce((acc, key) => {
    if (data[key] !== undefined) {
      acc[key] = data[key];
    }
    return acc;
  }, {});

const patientsHelper = {
  forCreate: (data) => buildFormData(pickFields(data)),

  forUpdate: (id, data) => ({
    id,
    body: buildFormData(pickFields(data)),
  }),
};
export const PatientSearchHelper = {
  forCreate: ({tracking_number}) =>
    buildFormData({
      tracking_number,
    }),
};
export default patientsHelper;